var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CockpitMatryoshkaItemHistoryList',{attrs:{"label-archive-id":_vm.labelArchiveId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }